
import { Paper, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from 'react';

export type StepMenuStepsProps = {
    sx?: SxProps<Theme>    
};

export default function StepMenuSteps({
    sx,
    children
}: PropsWithChildren<StepMenuStepsProps>) {
    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                overflow: "hidden",
                ...sx
            }}
            elevation={0}
        >
            {children}
        </Paper>
    );
}